import React, { createContext, useContext, useState, useEffect } from 'react';

// Crear el contexto
const AurelioBuilderContext = createContext();

// Provider del contexto
export function AurelioBuilderProvider({ children }) {
  // Inicializar estado desde localStorage
  const getInitialEditorData = () => {
    try {
      const savedEditorData = localStorage.getItem('aurelioEditorData');
      if (savedEditorData) {
        const parsed = JSON.parse(savedEditorData);
        console.log('AurelioBuilderContext - Loaded state from localStorage:', parsed);
        return parsed;
      }
    } catch (error) {
      console.error('Error loading editor data from localStorage:', error);
      // Si hay error, limpiar el localStorage corrupto
      localStorage.removeItem('aurelioEditorData');
    }
    console.log('AurelioBuilderContext - Using default state (editor closed)');
    return {
      isOpen: false,
      selectedTemplate: null,
    };
  };

  const [isFullscreen, setIsFullscreen] = useState(() => {
    const savedData = getInitialEditorData();
    return savedData.isOpen;
  });
  
  const [editorData, setEditorData] = useState(getInitialEditorData);

  // Guardar estado del editor en localStorage cuando cambie
  useEffect(() => {
    try {
      localStorage.setItem('aurelioEditorData', JSON.stringify(editorData));
    } catch (error) {
      console.error('Error saving editor data to localStorage:', error);
    }
  }, [editorData]);

  const enterFullscreen = (template = null) => {
    setIsFullscreen(true);
    setEditorData({
      isOpen: true,
      selectedTemplate: template,
    });
  };

  const exitFullscreen = () => {
    console.log('AurelioBuilderContext - Exiting fullscreen mode');
    setIsFullscreen(false);
    setEditorData({
      isOpen: false,
      selectedTemplate: null,
    });
    // Limpiar también el estado del lienzo cuando se sale intencionalmente
    try {
      localStorage.removeItem('editorState');
    } catch (error) {
      console.error('Error clearing editor state:', error);
    }
  };

  // Función para resetear completamente el estado (útil para debugging)
  const resetState = () => {
    console.log('AurelioBuilderContext - Resetting all state');
    setIsFullscreen(false);
    setEditorData({
      isOpen: false,
      selectedTemplate: null,
    });
    try {
      localStorage.removeItem('aurelioEditorData');
      localStorage.removeItem('editorState');
    } catch (error) {
      console.error('Error clearing localStorage:', error);
    }
  };

  const value = {
    isFullscreen,
    editorData,
    enterFullscreen,
    exitFullscreen,
    resetState,
  };

  return (
    <AurelioBuilderContext.Provider value={value}>
      {children}
    </AurelioBuilderContext.Provider>
  );
}

// Hook personalizado para usar el contexto
export function useAurelioBuilder() {
  const context = useContext(AurelioBuilderContext);
  if (!context) {
    throw new Error('useAurelioBuilder must be used within an AurelioBuilderProvider');
  }
  return context;
}

export default AurelioBuilderContext;
